import { getCourseRunStartText } from "@/lib/course/utils/getCourseRunTilePrimaryText";
import getNextCourseOneLineText from "../../utils/getNextCourseOneLineText";
import useTranslations from "@/i18n/useTranslations";

function CourseDateDisplay({
  oneLineStartDate,
  isCourseArchived,
  isCourseEnrollable,
  courseRun,
  seeMoreDatesHandler,
  endText,
  showEndDate,
}: {
  oneLineStartDate: boolean;
  isCourseArchived: boolean;
  isCourseEnrollable: boolean | null;
  courseRun: any;
  seeMoreDatesHandler: any;
  endText: string | null;
  showEndDate: boolean;
}) {
  const t = useTranslations("Course");
  const translate =
    t as unknown as import("@/lib/course/utils/getCourseInformation").CourseInfoTranslate;
  if (isCourseArchived || !isCourseEnrollable) {
    return (
      <span className="font-bold text-base">{t("thisCourseIsArchived")}</span>
    );
  }

  const startText = getCourseRunStartText(
    courseRun,
    !!seeMoreDatesHandler,
    translate,
  );
  const hasEndText = endText && showEndDate;
  const endTextClassName = seeMoreDatesHandler ? "text-sm" : "";

  if (oneLineStartDate) {
    return (
      <div className="text-center">
        <div className="text-lg font-bold">
          {getNextCourseOneLineText(startText, translate)}
        </div>
        {hasEndText && <div className={endTextClassName}>{endText}</div>}
      </div>
    );
  }

  return (
    <div className="text-center">
      {seeMoreDatesHandler && <div>{t("nextCourseStarts")}</div>}
      <div className="text-lg font-bold">{startText}</div>
      {hasEndText && <div className={endTextClassName}>{endText}</div>}
    </div>
  );
}

export default CourseDateDisplay;
